module.exports = __webpack_public_path__ + "img/dachstein-logo.953e5f64.png";